import React from "react";
import * as styles from "./LoadingTile.module.css";

interface Props {}

export const LoadingTile: React.FC<Props> = () => {
  return <div className={styles.container}></div>;
};
